<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>{{ editing ? 'Cập nhật' : 'Xem chi tiết' }} nguồn đồng bộ dữ liệu</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="ID nguồn đồng bộ dữ liệu: "
                                              label-for="input-name"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ syncDataSource.id }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Tên nguồn đồng bộ dữ liệu: "
                                              label-for="input-name"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              :label-class="editing ? 'required' : ''"
                                              label-align="left">
                                    <b-form-input type="text" id="input-name"
                                                  class="col-md-6"
                                                  v-if="editing"
                                                  aria-describedby="nameFeedback"
                                                  v-model="$v.syncDataSource.name.$model"
                                                  :state="$v.syncDataSource.name.$dirty? !$v.syncDataSource.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="nameFeedback">
                                        Vui lòng nhập tên
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">{{ syncDataSource.name }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Loại tài sản áp dụng: "
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <treeselect v-model="syncDataSource.appliedAssetTypeGroupIds"
                                                multiple
                                                v-if="editing"
                                                class="no-padding col-md-6"
                                                placeholder="--- Tất cả ---"
                                                :options="assetTypeGroups" />
                                    <label class="col-form-label" v-if="!editing">{{ (syncDataSource.appliedAssetTypeGroupNames || []).join(', ') }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="URL gửi yêu cầu báo cáo: "
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" class="col-md-6" v-if="editing" v-model="syncDataSource.reportRequestUrl"></b-form-input>
                                    <label class="col-form-label" v-if="!editing">{{ syncDataSource.reportRequestUrl }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="" :label-cols="4" label-cols-md="3">
                                    <b-button type="submit" variant="primary" v-if="editing"> Lưu</b-button>
                                    <b-button type="button" variant="secondary" :to="{ path: '../' }"> Quay lại</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'SyncDataSourceDetail',
        mixins: [validationMixin, mixins],
        data() {
            return {
                syncDataSource: {},
                editing: this.$route.meta.editing
            }
        },
        computed: {
            syncDataSourceId() {
                return this.$route.params.syncDataSourceId;
            },
            ...mapState({
                assetTypeGroups: (state, getters) => getters.assetTypeGroupTree,
            }),
        },
        validations: {
            syncDataSource: {
                name: { required }
            },
        },
        created() {
            this.loadSyncDataSourceDetail();
        },

        methods: {
            loadSyncDataSourceDetail() {
                var vm = this;
                return this.$services.get(`master-data/sync-data-sources/${this.syncDataSourceId}`).done(syncDataSource => {
                    vm.syncDataSource = syncDataSource;
                });
            },
            back() {
                this.$router.push({ path: '../' });
            },
            save() {
                this.$v.$touch();
                var vm = this;
                if (!vm.$v.$invalid) {
                    vm.$services.put(`master-data/sync-data-sources/${vm.syncDataSourceId}`, vm.syncDataSource).done(() => {
                        vm.$toastr.s('Cập nhật nguồn đồng bộ dữ liệu thành công');
                        vm.$store.dispatch("loadSyncDataSources");
                        vm.back();
                    });
                }
            },
        }
    }
</script>
<style scoped>
</style>
